export function calcularValorDescontoAnual({ consumoDinheiro, porcentagem }) {
  const MESES_ANO = 12;
  return consumoDinheiro * MESES_ANO * porcentagem;
}